import { connect } from 'react-redux'
import { addFilter, setActiveModal } from 'registry/actions'
import {
  getRegItemsCount,
  getEligibleForRegistryDiscount,
  getInitialRegItemsCount,
  getGiftsPurchasedCount,
} from 'registry/reducers'
import RegistrySidenav from './registry-sidenav'

const mapStateToProps = (state) => ({
  isEligibleForRegistryDiscount: getEligibleForRegistryDiscount(state),
  regItemsCount: getRegItemsCount(state) || getInitialRegItemsCount(state),
  giftsPurchasedCount: getGiftsPurchasedCount(state),
})

export default connect(mapStateToProps, { addFilter, setActiveModal })(
  RegistrySidenav
)
